export var NAME = 'serviceDetails';
export var SERVICE_DETAILS_CLEARED = "".concat(NAME, "/SERVICE_DETAILS_CLEARED");
export var SERVICE_DETAILS_UPDATED = "".concat(NAME, "/SERVICE_DETAILS_UPDATED");
export var FILE_TYPE_MANUSCRIPT = 'manuscript';
export var FILE_TYPE_FIGURE = 'figure';
export var FILE_TYPE_TABLE = 'table';